import create from 'zustand';
import { persist } from 'zustand/middleware';

const useRestaurantPOSStore = create(
  persist(
    (set) => ({
      contextOptions: [],
      activeStore: null,
      activeCashier: null,
      billoutState: null,
      setContextOptions: (options) => set({ contextOptions: options }),
      setActiveStore: (store) => set({ activeStore: store }),
      setActiveCashier: (cashier) => set({ activeCashier: cashier }),
      setBilloutState: (state) => set({ billoutState: state }),
    }),
    {
      name: 'restaurant-pos',
      getStorage: () => sessionStorage,
      partialize: (state) => ({
        contextOptions: state.contextOptions,
        activeStore: state.activeStore,
        activeCashier: state.activeCashier,
        billoutState: state.billoutState,
      }),
    }
  )
);

export default useRestaurantPOSStore;
